import { Component } from "react";
import TextFieldGroup, { SelectField } from "../common_input/TextFieldGroup";

//General Function
import dict from "../../Data/dict.json";
// import { get_country_names } from "../../App/validation/countries";
import countries from "../../Data/countries.json";
// import continents from "../../Data/continents.json"

export default class RegisterStep1 extends Component {
  render() {
    const language = localStorage?.language ? localStorage?.language : "ina";
    const countries_list = countries.map((country) => ({
      name: country.name,
      title: country.name,
    }));
    const { organization, onChange, errors, country } = this.props;
    return (
      <>
        <TextFieldGroup
          Title={dict["Your organization name"][language]}
          placeholder={`${dict["Enter your organization name"][language]}`}
          name="organization"
          value={organization}
          onChange={onChange}
          error={errors?.organization}
        />
        <SelectField
          Title={dict["Where the organization operates"][language]}
          list_array={countries_list}
          id="country"
          name="country"
          value={country}
          onChange={onChange}
          error={errors?.country}
          placeholder={`${dict["Choose country"][language]}`}
        />
      </>
    );
  }
}
